enum Permissions {
  InvoiceView = 'invoice:view',
  InvoiceCreate = 'invoice:create',
  InvoiceEdit = 'invoice:edit',
  HcpcsCodes = 'hcpcsCodes'
};

export default Permissions;
